import React from 'react';
import { Tooltip } from 'grab-ui';
import PropTypes from 'prop-types';

const WithTooltip = ({ hasTooltip, title, placement, trigger, children }) => {
  if (!hasTooltip) {
    return children;
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      trigger={trigger}
      mouseLeaveDelay={0}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

WithTooltip.defaultProps = {
  placement: 'bottom',
  trigger: 'hover',
  title: '',
};

WithTooltip.propTypes = {
  hasTooltip: PropTypes.bool.isRequired,
  title: PropTypes.string,
  placement: PropTypes.string,
  trigger: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default WithTooltip;
